/**
 * Theme Name: project-sscms v1.510.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - ef3817d8d]
 * Version: 1.510.0-2025-07-16T20-10-48
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
// Testimonial slider
function testimonialSlider($) {
    const testimonials = $('.testimonials[data-multiple-slides="1"]');
    
    for (var i = 0; i < testimonials.length; i++) {
        const testimonial = $(testimonials[i]);
        const slider = testimonial.find('.testimonial__slider');
        const nextArrow = testimonial.find('.next-arrow');
        const prevArrow = testimonial.find('.prev-arrow');
        const dotsWrapper = testimonial.find('.testimonial__dots-wrapper');

        if (typeof slickAnimate === "function") {
            slickAnimate(slider);
        }

        // use setTimeout to initialize each slider in its own JS task to avoid long-running JS tasks
        setTimeout(() => {
            slider.slick({
                infinite: true,
                fade: true,
                dots: true,
                arrows: true,
                speed: 500,
                slidesToShow: 1,
                adaptiveHeight: false,
                autoplay: true,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                appendDots: dotsWrapper,
                autoplaySpeed: 3750,
            });
        }, 0);
    }
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(function($) {
    testimonialSlider($);
});
